<template>
  <div class="">
    <el-form :inline="true" label-width="90px">
      <el-row :gutter="26">
        <el-col :span="22" class="key-input">
          <el-row :span="22">
            <el-col :span="12">
              <el-form-item label="搜索">
                <el-input
                  clearable
                  v-model="searchInfo.keyword"
                  placeholder="设备SN搜索"
                  size="mini"
                  suffix-icon="el-icon-search"
                  width="100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-checkbox v-model="searchInfo.current"
                  >当前活动（{{ this.promotion?.title || "" }}）</el-checkbox
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"> </el-col>
          </el-row>
        </el-col>
        <el-col
          :span="2"
          class="right-button"
          style="border-left: 1px #e5e6eb solid"
        >
          <el-button icon="el-icon-search" @click="search">查询</el-button>
          <el-button
            class="reset-btn"
            icon="el-icon-refresh-right"
            @click="reset"
          >
            重置
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <div style="border-bottom: 1px #e5e6eb solid; margin: 20px 0"></div>
    <div class="buttons">
      <div class="leftButton">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="addFlag = true"
        >
          添加
        </el-button>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-delete"
          @click="delSelected"
          :disabled="multipleSelection.length === 0"
        >
          批量删除
        </el-button>
      </div>
      <div class="rightButton">
        <el-button
          type="info"
          size="mini"
          icon="el-icon-download"
          @click="downloadExcel"
        >
          下载
        </el-button>
      </div>
    </div>
    <el-row>
      <el-table
        v-loading="loading"
        empty-text="暂无数据"
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="no" label="序号" width="65">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="设备类型"
          prop="deviceType"
          width="80"
        ></el-table-column>

        <el-table-column align="center" label="设备ID" prop="deviceId">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              :style="{
                color: '#165DFF',
                cursor: 'pointer',
              }"
              @click="goDevDetail(scope.row.gdid)"
            >
              {{ scope.row.deviceId || "--" }}
            </a>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="活动"
          prop="promotion"
        ></el-table-column>

        <el-table-column
          align="center"
          label="添加时间"
          prop="createdAt"
        ></el-table-column>

        <el-table-column align="center" label="状态" prop="uid" width="80">
          <template slot-scope="scope">
            {{ scope.row.uid ? "已报名" : "未报名" }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="激活时间"
          prop="firstBindTime"
        ></el-table-column>

        <el-table-column align="center" label="操作" prop="opr" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="font-weight: 400"
              @click="del(scope.row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog
      title="添加设备"
      :visible.sync="addFlag"
      width="60%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div>
        <el-input
          clearable
          v-model="deviceIds"
          placeholder="粘贴或输入设备SN号到此处"
          size="mini"
          width="100%"
        >
          <el-button slot="append" style="color: #165dff" @click="toTable"
            >确认</el-button
          >
        </el-input>
        <el-table
          empty-text="暂无数据"
          :data="deviceData"
          style="width: 100%; margin-top: 16px"
        >
          <el-table-column prop="no" label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="设备类型"
            prop="deviceType"
          ></el-table-column>

          <el-table-column
            align="center"
            label="设备ID"
            prop="deviceId"
          ></el-table-column>

          <el-table-column
            align="center"
            label="上传结果"
            prop="msg"
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="info"
          size="mini"
          :loading="uploading"
          @click="devDialogClose"
        >
          关 闭
        </el-button>
        <el-button
          type="primary"
          size="mini"
          :loading="uploading"
          @click="saveDevice"
        >
          上 传
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { exportToExcel, activeTableDataTransform } from "@/utils/util";
export default {
  props: {
    promotion: {},
  },
  data() {
    return {
      addFlag: false,
      tableData: [],
      searchInfo: {
        keyword: "",
        current: true,
      },
      loading: false,
      uploading: false,
      deviceIds: "",
      deviceData: [],
      multipleSelection: [],
      promotionMap: {},
    };
  },
  watch: {
    promotion(newVal, oldVal) {
      if (newVal.id) {
        this.getDataList();
      }
    },
  },
  mounted() {},
  methods: {
    async getPromotionName(id) {
      if (this.promotionMap[id]) {
        return this.promotionMap[id];
      } else {
        if (this.promotion?.id === id && this.promotion?.title) {
          return this.promotion?.title;
        }
        const res = await this.$get("/promotion/get", { id });
        const title = res.data?.data?.title || "";
        this.promotionMap[id] = title;
        return title;
      }
    },
    async downloadExcel() {
      const req = { deviceId: this.searchInfo.keyword };
      if (this.searchInfo.current) {
        req.id = this.promotion?.id;
      } else if (
        !(this.searchInfo.keyword && this.searchInfo.keyword.length >= 10)
      ) {
        this.$message({
          type: "warning",
          message: "请输入SN号",
        });
        return;
      }

      const { data } = await this.$get("/promotion/device/data", req);

      const arr = data.data || [];

      if (arr.length <= 0) {
        this.$message.warning("暂无设备");
        return;
      }

      this.totalTableData = arr.map((d) => ({
        ...d,
        status: d.uid ? "已报名" : "未报名",
      }));

      const tableData = activeTableDataTransform(this.totalTableData);
      exportToExcel(tableData, "promotion_device");
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    validSN(r) {
      let valid = false;
      let deviceType = "";
      if (r.length === 15 && r.substring(0, 4) === "Y007") {
        deviceType = "Y007";
        valid = true;
      }
      if (
        r.length === 15 &&
        (r.substring(0, 5) === "Y0030" || r.substring(0, 5) === "Y0031")
      ) {
        deviceType = "S3";
        valid = true;
      }
      if (
        r.length === 15 &&
        (r.substring(0, 5) === "Y0032" || r.substring(0, 5) === "Y0033")
      ) {
        deviceType = "Y003";
        valid = true;
      }
      if (
        r.length === 15 &&
        (r.substring(0, 5) === "Y0034" || r.substring(0, 5) === "Y0035")
      ) {
        deviceType = "K300";
        valid = true;
      }
      if (r.length === 15 && r.substring(0, 4) === "Y006") {
        deviceType = "Y006";
        valid = true;
      }
      if (r.length === 14 && r.substring(0, 2) === "55") {
        deviceType = "Y001S";
        valid = true;
      }
      let msg = valid ? "" : "无效编码";
      if (valid) {
        if (this.tableData?.some((d) => d.deviceId === r)) {
          valid = false;
          msg = "设备已存在";
        }
      }
      return { deviceType, valid, msg };
    },
    toTable() {
      if (this.deviceIds) {
        this.deviceData = this.deviceIds.split(/[,\s\t\n]+/).map((r) => {
          const { deviceType, valid, msg } = this.validSN(r);
          return {
            deviceId: r,
            deviceType,
            valid,
            msg,
          };
        });
      }
    },

    async saveDevice() {
      if (this.promotion.id) {
        const uplist = this.deviceData.filter((r) => r.valid);
        this.uploading = true;
        for (let i = 0; i < uplist.length; i++) {
          const r = uplist[i];
          try {
            const res = await this.$post(`/promotion/device/add`, {
              promotionId: this.promotion.id,
              deviceId: r.deviceId,
              deviceType: r.deviceType,
            });
            if (res.data?.code === 1000) {
              r.msg = "上传成功";
            } else {
              r.msg = res.data?.msg;
            }
          } catch (err) {
            r.msg = err.message;
          }
          this.deviceData = [...this.deviceData];
        }
        this.uploading = false;
      }
    },

    devDialogClose() {
      const isUpdate =
        this.deviceData.length && this.deviceData.every((r) => r.msg);
      this.addFlag = false;
      this.deviceIds = "";
      this.deviceData = [];
      if (isUpdate) {
        this.getDataList();
      }
    },

    del(id) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$post(`/promotion/device/del?id=${id}`, {}).then((res) => {
          if (res.data?.code === 1000) {
            this.getDataList();
          } else {
            this.$message.error(res.data?.msg);
          }
        });
      });
    },
    async delDevs() {
      const ids = this.multipleSelection.map((s) => s.id);
      for (const id of ids) {
        await this.$post(`/promotion/device/del?id=${id}`, {});
      }
      this.getDataList();
    },
    delSelected() {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.delDevs();
      });
    },
    // 查看用户详情
    // toUserDetail(scope) {
    //   if (this.$jumpPerm("user_detail")) {
    //     this.$router.push({
    //       path: "/userDetail",
    //       query: {
    //         id: scope.row.uid,
    //         tabs: "first",
    //       },
    //     });
    //   } else {
    //     this.$message({
    //       type: "error",
    //       message: "没有权限",
    //     });
    //   }
    // },
    // 查看设备详情
    goDevDetail(id) {
      if (this.$jumpPerm("device_detail")) {
        this.mskflag = false;
        this.$router.push({
          path: "/devDetail",
          query: {
            id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    getDataList() {
      const req = { deviceId: this.searchInfo.keyword };
      if (this.searchInfo.current) {
        req.id = this.promotion?.id;
      } else if (
        !(this.searchInfo.keyword && this.searchInfo.keyword.length >= 10)
      ) {
        this.$message({
          type: "warning",
          message: "请输入SN号",
        });
        return;
      }
      this.loading = true;
      this.$get("/promotion/device/data", req).then((res) => {
        this.loading = false;
        if (res.data?.code === 1000) {
          // this.tableData = res.data?.data || [];
          this.updatePName(res.data?.data || []);
        }
      });
    },

    async updatePName(list) {
      for (let i = 0; i < list.length; i++) {
        const ele = list[i];
        ele.promotion = await this.getPromotionName(ele.promotionId);
      }
      this.tableData = list;
    },

    search() {
      this.getDataList();
    },
    reset() {
      this.searchInfo = {
        keyword: "",
        current: true,
      };
      this.getDataList();
    },
  },
};
</script>

<style lang="less" scoped>
.submitted {
  color: #165dff;
  cursor: pointer;
  // width: 90px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 超出显示省略号 */
}
.el-popover {
  width: auto !important;
}
.right-button {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  .el-button {
    width: 82px;
    height: 28px;
    background-color: #165dff;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-top: 5px;
  }
  .reset-btn {
    color: #4e5969;
    background-color: #f2f3f5;
    margin-left: 0 !important;
    margin-top: 13px;
  }
}
::v-deep .key-input .el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .key-input1 {
  width: 100%;
}

::v-deep .key-input .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-form-item {
  display: flex !important;
}
.status-content {
  display: flex;
  width: 100%;
  align-items: center;
  // justify-content: space-between;
}
.status-color {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  // background-color: #ff7d00;
}
.audit-opinion-desc {
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}
.audit-opinion {
  display: block !important;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0px;
}
::v-deep .el-dialog__body {
  padding: 34px 20px 0px;
}
::v-deep .el-dialog__footer {
  text-align: right;
}
.dialog-footer {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.dialog-btn {
  display: flex;
  width: 60px;
  height: 32px;
  background: #f2f3f5;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  cursor: pointer;
}
.confirm-btn {
  background-color: #165dff;
  color: #ffffff;
  margin-left: 8px;
}
</style>
